import { ReactNode } from 'react';

import { PolicyCardForm } from './_components/PolicyCardForm';

import { RffCheckbox } from '@cast/shared-rff-ui';

type JvmMemoryFieldProps = {
  name: string;
  tooltipText?: ReactNode;
};

export const JvmMemoryField = ({ name, tooltipText }: JvmMemoryFieldProps) => {
  return (
    <PolicyCardForm
      label="Scale JVM memory"
      tooltipText={tooltipText}
      control={<RffCheckbox name={name} size="small" testId="enable-jvm" />}
    />
  );
};
